import { Link } from "@tanstack/react-router";
import { APPROVALS_PERMISSIONS, REISSUES_PERMISSIONS, REVOCATIONS_PERMISSIONS } from "@/app/nav";
import { useSession } from "@/auth/session";

/** Switches between the approval queues below desktop width; hidden when the user can only see one. */
export function ApprovalTabs() {
  const { can } = useSession();
  const tabs = [
    { to: "/approvals" as const, label: "Batches", permissions: APPROVALS_PERMISSIONS },
    { to: "/approvals/revocations" as const, label: "Revocations", permissions: REVOCATIONS_PERMISSIONS },
    { to: "/approvals/reissues" as const, label: "Re-issues", permissions: REISSUES_PERMISSIONS },
  ].filter((tab) => tab.permissions.every(can));
  if (tabs.length < 2) return null;
  return (
    <nav aria-label="Approval queues" className="flex gap-1 border-b border-zinc-200 text-sm lg:hidden">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          activeOptions={{ exact: true, includeSearch: false }}
          className="-mb-px border-b-2 px-3 py-2 font-medium"
          activeProps={{ className: "border-brand text-zinc-950" }}
          inactiveProps={{ className: "border-transparent text-zinc-500 hover:text-zinc-800" }}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
